<template>
    <div class="page-user-lsit">
        <div class="pg-breadcrumb">
            <div class="breadcrumb-item em">商品</div>
            <div class="breadcrumb-item">訂單詳情</div>
        </div>

        <Spin fix class="pg-sub-loading" v-if="isLoading">
            <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
            <div class="loading-text">Loading</div>
        </Spin>

        <div class="card-block">
            <Form inline class="pg-form-inline form-input-wrap" style="margin-left: 273px;margin-right: 273px;">
                <Steps :current="current">
                    <Step title="待發貨"></Step>
                    <Step title="已發貨"></Step>
                    <Step title="門店/智能櫃"></Step>
                    <Step title="簽收"></Step>
                </Steps>
            </Form>
        </div>
        <div class="sub_header">
            <div style="font-weight:bold;font-size: 24px;float: left;">{{order_current}}</div>

            <div class="pg-btn-wrap">
                 <!-- <div class="pg-btn style1" style="line-height: 30px;font-size: 16px;width: 70px;height: 30px;border-radius: 6px;float: right;">退貨</div> -->
                 <!-- <div class="pg-btn style3" style="line-height: 30px;font-size: 16px;width: 70px;height: 30px;border-radius: 6px;float: right;margin-left:10px;" v-if="this.current == 1">發貨</div> -->
                  <!-- <div class="pg-btn style2" style="line-height: 30px;font-size: 16px;width: 70px;height: 30px;border-radius: 6px;float: right;">備註</div> -->
            </div>
        </div>
        <div class="card-block-sub" style="border: 1px solid #CCCCCC;">
            <div class="pg-block">
                <div style="font-weight:bold;margin-bottom:25px;margin-top:10px;">基本信息</div>
                <Table style="margin-bottom:60px;" border no-data-text="暫無數據" :columns="table.column" :data="table.data"></Table>

                <div style="font-weight:bold;margin-bottom:25px;margin-top:10px;">收貨人信息</div>
                <Table style="margin-bottom:60px;" border no-data-text="暫無數據" :columns="table.column1" :data="table.data1"></Table>
                
                <div style="font-weight:bold;margin-bottom:25px;margin-top:10px;">商品信息</div>
                <Table style="margin-bottom:60px;" border no-data-text="暫無數據" :columns="table.column2" :data="table.data2">

                    <template slot-scope="{ row, index }" slot="order_image">
                    <div class="demo-image__preview" @click="handlesrcList(row.order_image)">
                            <el-image 
                                style="width: 50px; height: 50px"
                                :src="row.order_image"
                                :preview-src-list="srcList">
                            </el-image>
                        </div>
                    </template>
                    
                    <template slot-scope="{ row, index }" slot="price">
                        <div class="pg-btn-wrap">
                            <div>積分：{{row.order_amount_integral}}</div>
                            <div>集金幣：{{row.order_amount_jpoint}}</div>
                        </div>
                    </template>
                </Table>
                
                <div style="font-weight:bold;margin-bottom:25px;margin-top:10px;">操作信息</div>
                <Table style="margin-bottom:60px;" border no-data-text="暫無數據" :columns="table.column3" :data="table.data3">
                </Table>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data()
        {
            return {
                pageParam: {},
                isLoading: false,
                detail: [],
                srcList: [],
                current: 0,
                order_current: '',
                addresstype: '',
                table: {
                    column: [
                        {
                            title: '訂單編號',
                            key: 'order_number',
                            align: 'center',
                            minWidth: 220
                        },
                        {
                            title: '用戶電話',
                            key: 'user_phone',
                            align: 'center',
                            minWidth: 80
                        },
                        {
                            title: '下單時間',
                            key: 'order_time',
                            align: 'center',
                            minWidth: 80
                        },
                        {
                            title: '支付方式',
                            key: 'order_pay_type',
                            align: 'center',
                            minWidth: 80
                        },
                        {
                            title: '訂單來源',
                            key: 'order_source',
                            align: 'center',
                            minWidth: 80
                        },
                    ],
                    column1: [
                        {
                            title: '收貨人',
                            key: 'user_name',
                            align: 'center',
                            minWidth: 100
                        },
                        {
                            title: '用戶電話',
                            key: 'user_phone',
                            align: 'center',
                            minWidth: 100
                        },
                        {
                            title: '取貨地址',
                            key: 'pickup_address',
                            align: 'center',
                            minWidth: 100
                        },
                    ],
                    column2: [
                        {
                            title: '商品圖片',
                            slot: 'order_image',
                            align: 'center',
                            minWidth: 100
                        },
                        {
                            title: '商品名稱',
                            key: 'order_name',
                            align: 'center',
                            minWidth: 100
                        },
                        {
                            title: '單件價格',
                            slot: 'price',
                            align: 'center',
                            minWidth: 100
                        },
                        // {
                        //     title: '屬性',
                        //     key: 'perform',
                        //     align: 'center',
                        //     minWidth: 100
                        // },
                        {
                            title: '數量',
                            key: 'order_num',
                            align: 'center',
                            minWidth: 100
                        },
                        {
                            title: '小計',
                            key: 'total_price',
                            align: 'center',
                            minWidth: 100
                        },
                    ],
                    column3: [
                        {
                            title: '操作時間',
                            key: 'created_at',
                            align: 'center',
                            minWidth: 100
                        },
                        {
                            title: '訂單編號',
                            key: 'user_order',
                            align: 'center',
                            minWidth: 100
                        },
                        {
                            title: '操作者',
                            key: 'admin_operator',
                            align: 'center',
                            minWidth: 100
                        },
                        {
                            title: '訂單狀態',
                            key: 'order_log',
                            align: 'center',
                            minWidth: 100
                        },
                    ],
                    data: [],
                    data1: [],
                    data2: [],
                    data3: [],
                    data4: [],
                    data5: [],
                },
            };
        },
        
        created() {
            this.pageParam = this.$route.query;
            console.log(this.pageParam.id);
            if(this.pageParam.id == undefined) {
                this.pageParam.id = 0;
            }
            else {
                this.getOrderUsersList();
            }
        },
        methods: {
            handlesrcList(imgobj){
                this.srcList = [];
                for (let i = 0; i < imgobj.length; i++)
                {
                    this.srcList.push(imgobj);
                }
            },
            getOrderUsersList()
            {
                this.$Rq.requestAuth({
                    url: this.$Api.orderUsersDetailList,
                    method: 'get',
                    data: {
                        order_number: this.pageParam.id
                    }
                }).then((res) =>
                {
                    let tempArr = [];
                    let tempArr1 = [];
                    let tempArr2 = [];
                    let tempArr3 = [];
                    let order_source;
                    let order_pay_type;
                    let resData = res.data;

                    if (res.code == 0)
                    {
                        for (let i = 0; i < resData.data.length; i++)
                        {
                            if(resData.data[i].order_source == 1){
                                order_source = 'APP訂單';
                            }else if(resData.data[i].order_source == 3){
                                order_source = '第三方';
                            }

                            if(resData.data[i].order_status == 3){
                                this.current = '1';
                                this.order_current = '待發貨';
                            }else if(resData.data[i].order_status == 5){
                                this.current = '2';
                                this.order_current = '已發貨';
                            }else if(resData.data[i].order_status == 7){
                                this.current = '3';
                                this.order_current = '門店/智能櫃';
                            }else if(resData.data[i].order_status == 9){
                                this.current = '4';
                                this.order_current = '簽收';
                            }

                            if(resData.data[i].order_pay_type == 1){
                                order_pay_type = '積分';
                             }
                             else if(resData.data[i].order_pay_type == 2){
                                order_pay_type = '集金幣';
                             }
                             else if(resData.data[i].order_pay_type == 5){
                                order_pay_type = '積分/集金幣';
                             }
                             else {
                                order_pay_type = '未支付';
                             }

                            tempArr.push({
                                order_number: resData.data[i].order_number,
                                user_phone: resData.data[i].user_phone,
                                user_name: resData.data[i].user_name,
                                order_source: order_source,
                                order_pay_type: order_pay_type,
                                order_time: resData.data[i].order_time
                            });

                            tempArr1.push({
                                user_phone: resData.data[i].user_phone,
                                user_name: resData.data[i].user_name,
                                pickup_address: resData.data[i].pickup_address,
                            });

                            tempArr2.push({
                                order_image: resData.data[i].order_image,
                                order_name: resData.data[i].order_name,
                                order_num: resData.data[i].order_num,
                                order_amount_integral: resData.data[i].order_amount_integral / resData.data[i].order_num,
                                order_amount_jpoint: resData.data[i].order_amount_jpoint / resData.data[i].order_num,
                                total_price: Number(resData.data[i].order_amount_jpoint) + Number(resData.data[i].order_amount_integral),
                                // perform: '暫無'
                            });

                            console.log(resData.data[i].order_log.length);
                            if(resData.data[i].order_log.length > 0){
                                for (let j = 0; j < resData.data[i].order_log.length; j++)
                                {
                                    console.log(resData.data[i].order_log[j].order_log);
                                    tempArr3.push({
                                        order_log: resData.data[i].order_log[j].order_log,
                                        admin_operator: resData.data[i].order_log[j].admin_operator,
                                        user_order: resData.data[i].order_log[j].user_order,
                                        created_at: resData.data[i].order_log[j].created_at
                                    });
                                } 
                            }
                            
                        }
                        this.table.data = tempArr;
                        this.table.data1 = tempArr1;
                        this.table.data2 = tempArr2;
                        this.table.data3 = tempArr3;
                    }
                });
            },
            getDateTime(datetime){
                let date = new Date(datetime);
                let year = date.getFullYear();
                let month = date.getMonth() + 1;
                let day = date.getDate();
                let hour = date.getHours();
                let minute = date.getMinutes();
                let second = date.getSeconds();
                let week = date.getDay();
                let weekList = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];

                return {
                    date: `${this.formateNum(year)}-${this.formateNum(month)}-${this.formateNum(day)}`,
                    time: `${this.formateNum(hour)}:${this.formateNum(minute)}:${this.formateNum(second)}`,
                    week: weekList[week]
                };
            },
            formateNum(num){
                return num > 9 ? num : '0' + num;
            }
        },
        components: {   
        },
        computed: {
        },
    }
</script>

<style lang="scss" scoped>
    @import "orderdetailedList.scss";
</style>